import React, { useMemo } from 'react'
import PageLayout from '../../layout/page_layout'
import Button from '../../components/button'
import Box from '../../components/box'
import Link from '../../components/router/link'
import Grid from '../../components/grid'
import { usePaginatedList } from '../../hooks/usePaginatedList'
import { StudioMetadataWithPictureUrl } from '../../types'
import { StudioService } from '../../apilibrary'
import StudioCard from '../../components/card/studio_card'

const SearchStudioPage: React.FC = () => {
  const {
    items: studios,
    hasMore: hasMoreFetchStudioListings,
    fetchNextPage: fetchMoreStudioListings
  } = usePaginatedList<StudioMetadataWithPictureUrl>({
    pageSize: 12,
    fetchFunction: async (pagination) => {
      const {
        items,
        nextToken
      } = await StudioService.getAllStudios(pagination)
      const studiosWithMetadata: StudioMetadataWithPictureUrl[] = await Promise.all(items.map(async (studio) => {
        const coverPictureUrl = await studio.metadata.coverPicture.getPublicUrl()
        return {
          ...studio.metadata,
          coverPictureUrl
        }
      }))
      return {
        nextToken,
        items: studiosWithMetadata
      }
    }
  })

  const studioListJSX = useMemo(() => (
    studios.map((studio) =>
      <Grid item key={studio.id} sm={12} md={6} lg={3}>
        {/* eslint-disable-next-line @typescript-eslint/restrict-plus-operands */}
        <Link removeTextDecoration to={'/studio/' + studio.id}>
          <StudioCard title={studio.title} coverPictureUrl={studio.coverPictureUrl} rate={studio.rate} maxOccupancy={studio.maxOccupancy} />
        </Link>
      </Grid>
    )
  ), [studios])

  return (
    <PageLayout addGutter>
      <Box mx={4}>
        <Grid container spacing={2}>
          {studioListJSX}
        </Grid>
        {hasMoreFetchStudioListings && (
          <Box display="flex" mt={2} justifyContent={'center'}>
            <Button size='large' variant='outlined' onClick={fetchMoreStudioListings}>Load More</Button>
          </Box>
        )}
      </Box>
    </PageLayout>
  )
}

export default SearchStudioPage
